import React from "react";
import { Fragment } from "react";

const SideBarBlanks = ({ question, error, inputRefs, blankAnswer }) => {
  return (
    <div
      className="parent_fill-blanks"
      style={{ background: "#ffff", textAlign: "start" }}
    >
      {question &&
        question?.bankQuestion &&
        Array.isArray(question.bankQuestion) &&
        question.bankQuestion.map((word, index) => {
          // Check if this index matches any blanks in blanksBank
          const isBlank = question.blanksBank.some(
            (blank) => blank.indexNo === index
          );

          const matchingBlank = question.blanksBank.find(
            (blank) => blank.indexNo === index
          );

          // Safely find the corresponding student answer from blankAnswer
          const blankAnswerData = blankAnswer
            ?.flatMap((answer) => answer.studentSelectedBanks) // Flatten all studentSelectedBanks arrays
            ?.find((e) => e?.indexNo === matchingBlank?.indexNo); // Find the matching indexNo

          const calculateWidth = (text) => {
            // Create a canvas element
            const canvas = document.createElement("canvas");
            const context = canvas.getContext("2d");

            // Match input field font size and style
            context.font = "16px Arial"; // Replace 'Arial' with the actual font used in your CSS

            // Measure text width
            const textWidth = context.measureText(text || "").width;

            // Add padding (20px) and set a minimum width of 65px
            return Math.max(65, textWidth + 20);
          };

          const widthBlanks = calculateWidth(blankAnswerData?.answers?.[0]);

          return (
            <Fragment key={index}>
              {isBlank ? (
                <input
                  className={`blanks-field ${
                    word?.trim()
                      ? error[index]
                        ? "text-long"
                        : "enter_text"
                      : ""
                  }`}
                  type="text"
                  ref={(el) => (inputRefs.current[index] = el)}
                  style={{
                    paddingRight: "8px",
                    width: error[index] ? "80px" : `${widthBlanks}px `, // Dynamic width applied
                    // maxWidth: error[index] ? "80px" : `${widthBlanks}px`,
                  }}
                  value={blankAnswerData?.answers?.[0] || ""}
                  placeholder="blank"
                  disabled
                />
              ) : (
                <span>
                  {word} {}
                </span>
              )}
            </Fragment>
          );
        })}
    </div>
  );
};

export default SideBarBlanks;
